module.exports = __webpack_public_path__ + "static/media/5.228f1c2b.png";